module.exports = __webpack_public_path__ + "static/img/14010108.d97476d5.png";